/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useMemo, useState } from "react"
import { Box, useMediaQuery, useTheme } from "@mui/material"
import { InputDateMui } from "src/framework/components/forms/inputs/InputDateMui"
import { useObservable } from "src/framework/store/storeUtil"
import { FiltersStoreType, INITIAL_STATE, dashboardFilterStore$ } from '../../../store/dashboard/filters.store'
import { setDashboardFilter } from "../../../store/dashboard/filters.store"
import { subMonths } from "date-fns"
import { apiNoLoading } from "src/framework/providers/api"
import { authUser$ } from "src/framework/components/navigations/MenuUser"
import { ExtraInfoUsuario } from "src/providers/cadastros/ContaProvider/types"
import { Conta, ContaUsuario } from "src/store/global.store.types"
import { DashboardProvider } from "src/providers/dashboard"
import { Formater, TypeRecords } from "src/framework/commons/Formater"
import { CacheType, contaUsuario$ } from "src/store/global.store"
import { PermissionUtil } from "src/framework/commons/PermissionUtil"
import { InputComboBoxList } from "src/framework/components/forms/inputs/InputComboBoxList"
import { InputInfo } from "src/framework/components/forms/inputs/InputInfo/InputInfo"
import { InputComboBox } from "src/framework/components/forms/inputs/InputComboBox"

export const DASHBOARD_ETAPA_VENDA_OPTIONS = [
  { text: "Pré-orçamento", value: 'pre_orcamento', field: 'status_projeto'},
  { text: "Proposta Final", value: 'proposta_final', field: 'status_projeto'},
  { text: "Projeto Cancelado", value: 'cancelado', field: 'status_projeto'},
  { text: "Pagamento Reconhecido", value: 'pagamento_reconhecido', field: 'status_projeto'},
  { text: "Processando Informações do Pedido", value: 'processando_informacoes_pedido', field: 'status_projeto'},
  { text: "Em Trânsito", value: 'em_transito', field: 'status_projeto'},
  { text: "Produto Entregue", value: 'entregue', field: 'status_projeto'},
  { text: "Projeto Finalizado", value: 'finalizado', field: 'status_projeto'},  
]

const dashboardProvider = new DashboardProvider()
export function Filters(){
  const [listaDistribuidores, setListaDistribuidores] = useState<Conta[]>([])

  const authUser = useObservable<ExtraInfoUsuario | undefined>(authUser$)
  const dashboardFilterStore = useObservable<FiltersStoreType>(dashboardFilterStore$)
  const contaUsuario = useObservable<CacheType<ContaUsuario | null>>(contaUsuario$)

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    dashboardProvider.listarDistribuidores().then(res => {
      setListaDistribuidores(res || [])
    })
  }, [])

  const podeVerFiliais = useMemo(()=>{
    const filiais = contaUsuario?.data?.filiais || [];
    if (!filiais.length) return false;

    const permissions = PermissionUtil.getPermissions();
    return PermissionUtil.can(PermissionUtil.PERMISSION_PROJETOS_VISUALIZAR_FILIAIS, permissions) && !PermissionUtil.isAdministrador(permissions)
  },[contaUsuario?.data?.filiais])

  useEffect(()=>{
    if (podeVerFiliais && contaUsuario?.data?.distribuidor?.id) {
      setDashboardFilter('distribuidor', contaUsuario.data.distribuidor)
    }
  }, [contaUsuario?.data?.distribuidor, podeVerFiliais])

  const renderDistribuidorInput = useCallback(()=>{
    if (authUser?.isRevenda) return <></>
    if (authUser?.isIntelbras) {
      return (
        <InputComboBoxList
          id={`lista-distribuidores-dashboard`}
          key={`lista-distribuidores-dashboard`}
          label={"Distribuidor"}
          textField="nome"
          valueField="id"
          disabled={(listaDistribuidores || []).length === 0}
          options={listaDistribuidores || []}
          value={dashboardFilterStore?.distribuidor}
          autoComplete
          renderOptions={(option: any) => {
            return `${option.nome} - ${Formater.toString(option.cnpj_cpf, TypeRecords.CPF_CNPJ)}`
          }}
          renderOptionsLabel={(option: any) => {
            return `${option.nome}`
          }}
          onChange={(value) => {
            setDashboardFilter('revenda', null)
            setDashboardFilter("distribuidor", value)
          }}
        />
      )
    } 

    if (podeVerFiliais && contaUsuario?.data?.distribuidor?.id) {
      return (
        <InputComboBoxList
          id={`lista-distribuidores-dashboard`}
          key={`lista-distribuidores-dashboard`}
          label={"Distribuidor"}
          textField="nome"
          valueField="id"
          options={[contaUsuario.data.distribuidor, ...(contaUsuario.data.filiais || [])]}
          value={dashboardFilterStore?.distribuidor}
          autoComplete
          renderOptions={(option: any) => {
            return `${option.nome} - ${Formater.toString(option.cnpj_cpf, TypeRecords.CPF_CNPJ)}`
          }}
          renderOptionsLabel={(option: any) => {
            return `${option.nome}`
          }}
          onChange={(value) => {
            setDashboardFilter('revenda', null)
            setDashboardFilter("distribuidor", value)
          }}
        />
      )
    }

    return (
      <InputInfo
        label="Distribuidor"
        text={authUser?.distribuidor_nome || ''}
      />
    )
  },[podeVerFiliais, contaUsuario, authUser?.isRevenda, authUser?.isIntelbras, authUser?.distribuidor_nome, listaDistribuidores, dashboardFilterStore?.distribuidor])

  const renderRevendaInput = useCallback(()=>{
    if (authUser?.isIntelbras || authUser?.isDistribuidor) {
      return (
        <InputComboBox
          key={`dashboard-revenda`}
          path={dashboardFilterStore?.distribuidor?.id ? `/cadastros/contas/distribuidores/${dashboardFilterStore.distribuidor.id}/revendas` : authUser.distribuidor_id ? `/cadastros/contas/distribuidores/${authUser.distribuidor_id}/revendas` :""}
          //path={dashboardFilterStore?.distribuidor?.id ? `/cadastros/contas/revendas/${dashboardFilterStore.distribuidor.id}` : ""}
          label={"Revenda"}
          provider={apiNoLoading}
          disabled={(!dashboardFilterStore?.distribuidor?.id && !authUser.distribuidor_id) || (podeVerFiliais && !dashboardFilterStore?.distribuidor?.id)}
          value={dashboardFilterStore?.revenda || null}
          textField="nome"
          valueField="id"
          renderOptions={(option: any) => {
            return `${option.nome} - ${Formater.toString(option.cnpj_cpf, TypeRecords.CPF_CNPJ)}`
          }}
          renderOptionsLabel={(option: any) => {
              return option.nome}
          }
          onChange={(value) => {
            setDashboardFilter("revenda", value)
          }}
        />
      )
    }

    if (!authUser?.revenda_nome) return <></>

    return (
      <InputInfo
        label="Revenda"
        text={authUser?.revenda_nome || ''}
      />
    )
  },[podeVerFiliais, dashboardFilterStore?.distribuidor, dashboardFilterStore?.revenda, authUser?.isIntelbras, authUser?.revenda_nome, authUser?.isDistribuidor])

  return (
    <>
      <Box marginTop={"16px"} className="row">
        <div className="X12 M4">
          <InputDateMui
            margin="dense"
            label={"Período Inicial"}
            helperText="Data de criação do projeto"
            fullWidth
            value={dashboardFilterStore?.startDate}
            onChange={date => setDashboardFilter("startDate", date || null)}
            minDate={dashboardFilterStore?.endDate ? subMonths(new Date(dashboardFilterStore?.endDate), 3) : undefined}
            maxDate={dashboardFilterStore?.endDate ? new Date(dashboardFilterStore?.endDate) : new Date()}
          />
        </div>
        <div className="X12 M4">
          <InputDateMui
            margin="dense"
            label={"Período Final"}
            helperText="Data de criação do projeto"
            fullWidth
            value={dashboardFilterStore?.endDate}
            onChange={date => setDashboardFilter("endDate", date || null)}
            maxDate={new Date()}
          />
        </div>
        <div className="X12 M4" style={{ marginTop: '-8px' }}>
          <InputComboBoxList
            id={`etapa-venda-dashboard`}
            key={`etapa-venda-dashboard`}
            label={"Etapa de venda"}
            textField="text"
            disableClearable={dashboardFilterStore?.statusProjeto?.value === ''}
            //disableClearable={dashboardFilterStore?.etapaVenda?.value === ''}
            valueField="value"
            options={[{ text: 'Todos', value: '' }, ...DASHBOARD_ETAPA_VENDA_OPTIONS]}
            value={dashboardFilterStore?.statusProjeto || null}
            //value={dashboardFilterStore?.etapaVenda || null}
            autoComplete
            renderOptions={(option: any) => {
              return `${option.text}`
            }}
            renderOptionsLabel={(option: any) => {
              return `${option.text}`
            }}
            onChange={(value)=> setDashboardFilter("statusProjeto", value || INITIAL_STATE.statusProjeto)}
            //onChange={(value) => setDashboardFilter("etapaVenda", value || INITIAL_STATE.etapaVenda)}
          />
        </div>
      </Box>
      <Box marginTop={!isMobile ? '16px' : 0} className="row">
        <div className="X12 M6" style={{ marginTop: !isMobile ? '-8px' : 0 }}>
          {renderDistribuidorInput()}
        </div>
        <div className="X12 M6" style={{ marginTop: !isMobile ? '-8px' : 0 }}>
          {renderRevendaInput()}
        </div>
      </Box>
    </>
  )
}